import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { getFaqItems } from '../lib/faqContent';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const { t } = useLanguage();
  const faqs = getFaqItems(t);

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4 max-w-3xl">
        <h2 className="text-3xl md:text-5xl font-bold text-primary-950 text-center mb-12">
          {t('sections.faqTitle')}
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border rounded-lg px-5 mb-3">
              <AccordionTrigger className="text-left hover:no-underline py-4">
                <h3 className="text-lg font-semibold text-primary-900 pr-4">{faq.q}</h3>
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 pb-4 leading-relaxed">
                <p className="text-gray-900 font-medium mb-2">{faq.lead}</p>
                <p>{faq.detail}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
